import { useCallback } from 'react';
import { useAnalytics } from '@funtech-int/yango-shared';

import {
    createAnalyticsEvents,
    type PlayerContentPreparedAnalyticsParams,
} from '../createAnalyticsEvents';

export function usePlayerContentPrepared() {
    const analytics = useAnalytics(createAnalyticsEvents);

    return useCallback(
        (params: PlayerContentPreparedAnalyticsParams) => {
            analytics.playerContentPrepared(params);
        },
        [analytics]
    );
}
